<template>
  <div
    class="row basic-box leader-user-card user-card"
    @mouseover="toggleButtonVisibility(true)"
    @mouseleave="toggleButtonVisibility(false)"
  >
    <div class="col-4 no-gutters profile-image-col">
      <div class="user-image-container">
        <div class="profile image-wrapper">
          <user-image :user="user" class="user-image" />
        </div>
      </div>

      <div class="user-name">
        <router-link class="user-name-link" :to="`/users/${user._id}`">{{
          user.userName
        }}</router-link>
      </div>
      <div class="row data-row d-none d-lg-flex">
        <transition appear mode="out-in">
          <div class="col-12">
            <div class="row data-row">
              <div class="col-12 button-col">
                <base-button
                  :text="$t('competition.sendCredit')"
                  :disabled="isButtonDisabled"
                  class="feedback-button"
                  @click="showFeedbackModal(user._id)"
                />
              </div>
              <div
                class="col-6 data-col"
                v-html="$t('userCard.won', { won: user.won })"
              ></div>
              <div
                class="col-6 data-col"
                v-if="
                  loggedInUserProfile.role === 1 ||
                  loggedInUserProfile.company.privacyLevel === 0
                "
                v-html="$t('userCard.MP', { points: user.balance || 0 })"
              ></div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="col-8">
      <div class="row">
        <div class="col-12">
          <div
            class="title"
            v-html="
              $t('leaderUserCard.pointsFeedbacks', {
                points: user.subBalance.income,
                feedbacks: user.votes,
              })
            "
          ></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <carousel
            class="carousel"
            :autoplay="true"
            :is-touch="true"
            :per-page="1"
            :autoplayTimeout="10000"
            :mouse-drag="false"
          >
            <slide
              v-for="(transaction, index) in user.groupedTransactions"
              :key="index"
            >
              <div class="reason">"{{ transaction._id }}"</div>
              <div class="senders">
                <div
                  class="sender-image-wrapper"
                  v-for="(sender, index) in transaction.users"
                  :key="index"
                >
                  <user-image :user="sender" class="user-image" />
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

import UserImage from './UserImage';
import UserCard from './UserCard';

export default {
  name: 'LeaderUserCard',
  mixins: [UserCard],
  components: {
    UserImage,
    Carousel,
    Slide,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    responsive: {
      0: {
        items: 1,
      },
    },
  },
  data() {
    return {
      reasons: [],
    };
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    isButtonDisabled() {
      return this.loggedInUserProfile._id == this.user._id;
    },
  },
};
</script>

<style lang="scss" scoped>
.leader-user-card {
  background: rgb(51, 128, 195);
  background: linear-gradient(
    90deg,
    rgba(51, 128, 195, 1) 0%,
    rgba(98, 45, 144, 1) 49%
  );
  .user-image-container {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    .user-image {
      width: 100px;
      height: 100px;
      >>> img {
        border: 3px solid white;
        width: 100%;
      }
    }
    .image-wrapper {
      position: relative;
    }
    .rank-image {
      max-height: 30px;
      position: absolute;
      bottom: 3%;
      left: 3%;
      background-color: white;
      border-radius: 50%;
      padding: 5px;
      z-index: 1;
    }
  }
  .user-name {
    color: white;
    font-size: 1.2vw;
    font-weight: 100;
    .user-name-link {
      color: white;
    }
  }
  .button-col {
    display: none;
    -webkit-transition: all 350ms ease-out;
    -moz-transition: all 350ms ease-out;
    -o-transition: all 350ms ease-out;
    -ms-transition: all 350ms ease-out;
    transition: all 350ms ease-out;
  }
  &:hover {
    .button-col {
      display: block;
      -webkit-transition: all 350ms ease-out;
      -moz-transition: all 350ms ease-out;
      -o-transition: all 350ms ease-out;
      -ms-transition: all 350ms ease-out;
      transition: all 350ms ease-out;
    }
    .data-col {
      display: none;
      -webkit-transition: all 350ms ease-out;
      -moz-transition: all 350ms ease-out;
      -o-transition: all 350ms ease-out;
      -ms-transition: all 350ms ease-out;
      transition: all 350ms ease-out;
    }
    .data-row {
      opacity: 1;
    }
  }
  .data-row {
    color: white;
    opacity: 0.5;
    margin: 10px 0px;
    font-size: 1vw;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    .col-6 {
      margin: 0;
      padding: 0;
    }
  }
  .profile-image-col {
    border-right: 2px solid rgba(10, 8, 25, 0.04);
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .carousel {
    width: 100%;
    >>> .VueCarousel-dot-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0 !important;
      .VueCarousel-dot {
        &.VueCarousel-dot--active {
          background-color: rgba(255, 255, 255, 0.9) !important;
          width: 0.55vw !important;
          height: 0.55vw !important;
          opacity: 1;
        }
        padding: 5px !important;
        margin: 0 !important;
        opacity: 0.5;
        width: 0.45vw !important;
        height: 0.45vw !important;
        outline: none;
      }
      >>> .VueCarousel-pagination {
        position: absolute;
      }
    }
    .reason {
      color: white;
      font-size: 16px;
      width: 100%;
      margin: 0 auto;
      font-style: italic;
      text-align: left;
    }
  }
  .title {
    color: white;
    font-size: 14px;
    text-align: left;
    font-weight: 100;
    margin: 20px 0;
    >>> span {
      font-size: 19px;
      font-weight: bolder;
    }
  }
  .senders {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    align-items: center;
    flex-direction: row;
    .sender-image-wrapper {
      width: 30px;
      height: 30px;
      margin-right: -15px;
      >>> img {
        border: 2px solid white;
      }
    }
  }
  .feedback-button {
    opacity: 1;
    >>> .base-button {
      background-color: transparent !important;
      border: 2px solid white !important;
    }
  }
}
</style>
